export const SetToast = data => dispatch => dispatch({ type: 'SET_TOAST', data })
export const CloseToast = () => dispatch => dispatch({ type: 'CLOSE_TOAST' })
export const SetTimeoutId = data => dispatch => dispatch({ type: 'SET_TIMEOUT_ID', data })
export const ClearTimeout = () => dispatch => dispatch({ type: 'CLEAR_TIMEOUT' })